var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3816_11875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E6F1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.1C30.3078 27.1 33.8 23.6078 33.8 19.3C33.8 14.9922 30.3078 11.5 26 11.5C21.6922 11.5 18.2 14.9922 18.2 19.3C18.2 23.6078 21.6922 27.1 26 27.1Z",
    fill: "#0076A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 50.5C7.8 40.4484 15.9484 32.3 26 32.3C36.0516 32.3 44.2 40.4484 44.2 50.5H7.8Z",
    fill: "#0076A8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 49.5,
    height: 49.5,
    rx: 24.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3816_11875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.d29d856f9fc7a47e7dda570ebac3409d.svg";
export { ForwardRef as ReactComponent };